import { render, staticRenderFns } from "./ChangeOfDirectorsForeign.vue?vue&type=template&id=3529743e&scoped=true&"
import script from "./ChangeOfDirectorsForeign.vue?vue&type=script&lang=js&"
export * from "./ChangeOfDirectorsForeign.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfDirectorsForeign.vue?vue&type=style&index=0&id=3529743e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3529743e",
  null
  
)

export default component.exports